

export const BancorConverterRegistryAbi = [
   {
      "constant": false,
      "inputs": [
         {
            "name": "_adminOnly",
            "type": "bool"
         }
      ],
      "name": "restrictRegistryUpdate",
      "outputs": [

      ],
      "payable": false,
      "stateMutability": "nonpayable",
      "type": "function"
   },
   {
      "constant": true,
      "inputs": [

      ],
      "name": "getSmartTokens",
      "outputs": [
         {
            "name": "",
            "type": "address[]"
         }
      ],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
   },
   {
      "constant": true,
      "inputs": [
         {
            "name": "_smartTokens",
            "type": "address[]"
         }
      ],
      "name": "getConvertersBySmartTokens",
      "outputs": [
         {
            "name": "",
            "type": "address[]"
         }
      ],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
   },
   {
      "constant": true,
      "inputs": [
         {
            "name": "_value",
            "type": "address"
         }
      ],
      "name": "isConvertibleToken",
      "outputs": [
         {
            "name": "",
            "type": "bool"
         }
      ],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
   },
   {
      "constant": true,
      "inputs": [
         {
            "name": "_value",
            "type": "address"
         }
      ],
      "name": "isSmartToken",
      "outputs": [
         {
            "name": "",
            "type": "bool"
         }
      ],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
   },
   {
      "constant": false,
      "inputs": [

      ],
      "name": "updateRegistry",
      "outputs": [

      ],
      "payable": false,
      "stateMutability": "nonpayable",
      "type": "function"
   },
   {
      "constant": true,
      "inputs": [

      ],
      "name": "getConvertibleTokens",
      "outputs": [
         {
            "name": "",
            "type": "address[]"
         }
      ],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
   },
   {
      "constant": true,
      "inputs": [

      ],
      "name": "prevRegistry",
      "outputs": [
         {
            "name": "",
            "type": "address"
         }
      ],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
   },
   {
      "constant": true,
      "inputs": [

      ],
      "name": "getConvertibleTokenCount",
      "outputs": [
         {
            "name": "",
            "type": "uint256"
         }
      ],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
   },
   {
      "constant": false,
      "inputs": [
         {
            "name": "_converter",
            "type": "address"
         }
      ],
      "name": "addConverter",
      "outputs": [

      ],
      "payable": false,
      "stateMutability": "nonpayable",
      "type": "function"
   },
   {
      "constant": true,
      "inputs": [
         {
            "name": "_convertibleToken",
            "type": "address"
         },
         {
            "name": "_value",
            "type": "address"
         }
      ],
      "name": "isConvertibleTokenSmartToken",
      "outputs": [
         {
            "name": "",
            "type": "bool"
         }
      ],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
   },
   {
      "constant": false,
      "inputs": [

      ],
      "name": "acceptOwnership",
      "outputs": [

      ],
      "payable": false,
      "stateMutability": "nonpayable",
      "type": "function"
   },
   {
      "constant": true,
      "inputs": [

      ],
      "name": "getLiquidityPoolCount",
      "outputs": [
         {
            "name": "",
            "type": "uint256"
         }
      ],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
   },
   {
      "constant": true,
      "inputs": [

      ],
      "name": "registry",
      "outputs": [
         {
            "name": "",
            "type": "address"
         }
      ],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
   },
   {
      "constant": true,
      "inputs": [

      ],
      "name": "getLiquidityPools",
      "outputs": [
         {
            "name": "",
            "type": "address[]"
         }
      ],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
   },
   {
      "constant": true,
      "inputs": [
         {
            "name": "_reserveTokens",
            "type": "address[]"
         },
         {
            "name": "_reserveRatios",
            "type": "uint256[]"
         }
      ],
      "name": "getLiquidityPoolByReserveConfig",
      "outputs": [
         {
            "name": "",
            "type": "address"
         }
      ],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
   },
   {
      "constant": true,
      "inputs": [
         {
            "name": "_index",
            "type": "uint256"
         }
      ],
      "name": "getConvertibleToken",
      "outputs": [
         {
            "name": "",
            "type": "address"
         }
      ],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
   },
   {
      "constant": true,
      "inputs": [

      ],
      "name": "owner",
      "outputs": [
         {
            "name": "",
            "type": "address"
         }
      ],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
   },
   {
      "constant": true,
      "inputs": [
         {
            "name": "_converter",
            "type": "address"
         }
      ],
      "name": "isConverterValid",
      "outputs": [
         {
            "name": "",
            "type": "bool"
         }
      ],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
   },
   {
      "constant": false,
      "inputs": [
         {
            "name": "_converter",
            "type": "address"
         }
      ],
      "name": "removeConverter",
      "outputs": [

      ],
      "payable": false,
      "stateMutability": "nonpayable",
      "type": "function"
   },
   {
      "constant": true,
      "inputs": [
         {
            "name": "_index",
            "type": "uint256"
         }
      ],
      "name": "getSmartToken",
      "outputs": [
         {
            "name": "",
            "type": "address"
         }
      ],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
   },
   {
      "constant": true,
      "inputs": [
         {
            "name": "_convertibleToken",
            "type": "address"
         }
      ],
      "name": "getConvertibleTokenSmartTokenCount",
      "outputs": [
         {
            "name": "",
            "type": "uint256"
         }
      ],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
   },
   {
      "constant": true,
      "inputs": [
         {
            "name": "_index",
            "type": "uint256"
         }
      ],
      "name": "getLiquidityPool",
      "outputs": [
         {
            "name": "",
            "type": "address"
         }
      ],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
   },
   {
      "constant": false,
      "inputs": [

      ],
      "name": "restoreRegistry",
      "outputs": [

      ],
      "payable": false,
      "stateMutability": "nonpayable",
      "type": "function"
   },
   {
      "constant": true,
      "inputs": [

      ],
      "name": "adminOnly",
      "outputs": [
         {
            "name": "",
            "type": "bool"
         }
      ],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
   },
   {
      "constant": true,
      "inputs": [

      ],
      "name": "newOwner",
      "outputs": [
         {
            "name": "",
            "type": "address"
         }
      ],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
   },
   {
      "constant": true,
      "inputs": [
         {
            "name": "_convertibleToken",
            "type": "address"
         },
         {
            "name": "_index",
            "type": "uint256"
         }
      ],
      "name": "getConvertibleTokenSmartToken",
      "outputs": [
         {
            "name": "",
            "type": "address"
         }
      ],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
   },
   {
      "constant": true,
      "inputs": [

      ],
      "name": "getSmartTokenCount",
      "outputs": [
         {
            "name": "",
            "type": "uint256"
         }
      ],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
   },
   {
      "constant": true,
      "inputs": [
         {
            "name": "_value",
            "type": "address"
         }
      ],
      "name": "isLiquidityPool",
      "outputs": [
         {
            "name": "",
            "type": "bool"
         }
      ],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
   },
   {
      "constant": false,
      "inputs": [
         {
            "name": "_newOwner",
            "type": "address"
         }
      ],
      "name": "transferOwnership",
      "outputs": [

      ],
      "payable": false,
      "stateMutability": "nonpayable",
      "type": "function"
   },
   {
      "constant": true,
      "inputs": [
         {
            "name": "_convertibleToken",
            "type": "address"
         }
      ],
      "name": "getConvertibleTokenSmartTokens",
      "outputs": [
         {
            "name": "",
            "type": "address[]"
         }
      ],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
   },
   {
      "inputs": [
         {
            "name": "_registry",
            "type": "address"
         }
      ],
      "payable": false,
      "stateMutability": "nonpayable",
      "type": "constructor"
   },
   {
      "anonymous": false,
      "inputs": [
         {
            "indexed": true,
            "name": "_smartToken",
            "type": "address"
         }
      ],
      "name": "SmartTokenAdded",
      "type": "event"
   },
   {
      "anonymous": false,
      "inputs": [
         {
            "indexed": true,
            "name": "_smartToken",
            "type": "address"
         }
      ],
      "name": "SmartTokenRemoved",
      "type": "event"
   },
   {
      "anonymous": false,
      "inputs": [
         {
            "indexed": true,
            "name": "_liquidityPool",
            "type": "address"
         }
      ],
      "name": "LiquidityPoolAdded",
      "type": "event"
   },
   {
      "anonymous": false,
      "inputs": [
         {
            "indexed": true,
            "name": "_liquidityPool",
            "type": "address"
         }
      ],
      "name": "LiquidityPoolRemoved",
      "type": "event"
   },
   {
      "anonymous": false,
      "inputs": [
         {
            "indexed": true,
            "name": "_convertibleToken",
            "type": "address"
         },
         {
            "indexed": true,
            "name": "_smartToken",
            "type": "address"
         }
      ],
      "name": "ConvertibleTokenAdded",
      "type": "event"
   },
   {
      "anonymous": false,
      "inputs": [
         {
            "indexed": true,
            "name": "_convertibleToken",
            "type": "address"
         },
         {
            "indexed": true,
            "name": "_smartToken",
            "type": "address"
         }
      ],
      "name": "ConvertibleTokenRemoved",
      "type": "event"
   },
   {
      "anonymous": false,
      "inputs": [
         {
            "indexed": true,
            "name": "_prevOwner",
            "type": "address"
         },
         {
            "indexed": true,
            "name": "_newOwner",
            "type": "address"
         }
      ],
      "name": "OwnerUpdate",
      "type": "event"
   }
]